<div class="ontario-column ontario-small-12 grey-background">
  <div class="search-criteria-tablet-container padding-top-0 grey-background" style="margin-left: 0;">
    <div class="dialog-header">
      <div class="inline-block float-left title"> {{'Worker.FiltersAndSort' | translate}}</div>
      <button class="inline-block close-icon float-right" (click)="closeDialog()">
        <img src="assets/images/icon-close.svg" alt="Close">
      </button>
    </div>
    <!-- Sort -->
    <div class="ontario-row">
      <div class="ontario-column form-input-div ontario-small-12 float-left">
        <div class="other-group-buttons">
          <label for="sortBy" id="sort-by-label">
            {{ 'TrainingProgramSearch.SortBy' | translate }}
          </label>
          <app-dropdown [currentLang]="currentLang" [options]="sortingOptions"
            [formValue]="notificationSearchForm.sortingOption"
            (formValueChange)="notificationSearchForm.sortingOption=$event;">
          </app-dropdown>
        </div>
      </div>
    </div>
    <div class="ontario-row">
      <!-- From Date -->
      <div class="ontario-column form-input-div ontario-small-6">
        <label class="input-label">{{'General.FromDate' | translate}}</label>
        <input type="date" [max]="notificationSearchForm.toDate| date : 'yyyy-MM-dd'"
          [ngModel]="notificationSearchForm.fromDate | date : 'yyyy-MM-dd'"
          (ngModelChange)="StartDateChange($event)"
          class="ontario-date-input start-date ng-untouched ng-pristine ng-valid">
        </div>

        <!-- To Date -->
        <div class="ontario-column form-input-div ontario-small-6">
          <label class="input-label">{{'General.ToDate' | translate}}</label>
          <input type="date" [min]="notificationSearchForm.fromDate| date : 'yyyy-MM-dd'"
            [ngModel]="notificationSearchForm.toDate | date : 'yyyy-MM-dd'"
            (ngModelChange)="EndDateChange($event)"
            class="ontario-date-input start-date ng-untouched ng-pristine ng-valid">
          </div>
        </div>

        @if (!ValidStartandEndDate()) {
          <div class="ontario-row">
            <mat-error>
              {{'TrainingSchedules.OneDateisRequired' | translate}}
            </mat-error>
          </div>
        }

        <div class="ontario-row ontario-padding-top-16-!">
          <div class="ontario-column form-input-div ontario-small-12">
            <app-horizontal-radio-button-list [label]="'NotificationSearch.Show' | translate"
              [currentLang]="currentLang" [(value)]="notificationSearchForm.notificationStatus"
              [radioButtonOptions]="notificationStatuses">
            </app-horizontal-radio-button-list>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-view">
      <div class="border-bottom"></div>
      <div class="fixed-bottom">
        <div class="menu-div menu-div-left">
          <a (click)="initSearchForm();" >Reset</a>
        </div>
        <div class="menu-div menu-div-right">
          <a (click)="onApplyFilters()">Apply</a>
        </div>
      </div>
    </div>